export const numberFormat = new Intl.NumberFormat('no-NB', {
  maximumFractionDigits: 2
});
